import QueryParameterBuilder from '@/lib/query-parameter/QueryParameterBuilder';
import { requestMapApi } from '@/api/request-map';
import RequestMap from '@/entity/RequestMap';
import PaginationOutput from '@/helpers/PaginationOutput';
export const requestMapService = {
    /**
     * 바로고 맵데이터 조회
     * https://dev-zoo-client-api.barogo.io/docs/api-guide.html#_4_27_%EC%A7%80%EB%8F%84_%EB%8D%B0%EC%9D%B4%ED%84%B0_%EC%A1%B0%ED%9A%8C
     */
    async getBrgMapAddressList(serviceData) {
        const reqBody = serviceData.createReqBody();
        const response = await requestMapApi.getBrgMapAddressList(reqBody);
        return PaginationOutput.adaptorFactory(response, RequestMap);
    },
    /**
     * 세부 지명 지역 코드 조회 (서울, 경기등..)
     * https://dev-zoo-client-api.barogo.io/docs/common/area-type.html
     */
    async getAreaList() {
        const response = await requestMapApi.getAreaList();
        return response.data;
    },
    /**
     * 세부지명 요청 리스트 조회
     */
    async getItemList(param = {
        pageNumber: 1,
        pageSize: '20',
    }) {
        const params = new QueryParameterBuilder()
            .addPage(param.pageNumber)
            .addSize(param.pageSize);
        const response = await requestMapApi.getItemList(params.build());
        return PaginationOutput.adaptorFactory(response, RequestMap);
    },
    /**
     * 단건 취소
     */
    async cancelItem(serviceData) {
        const response = await requestMapApi.cancelItem(serviceData.createReqBody());
        return response;
    },
    /**
     * 세부지명 요청 등록
     */
    async createItem(serviceData) {
        const response = await requestMapApi.postItem(serviceData.createReqBody());
        return response.data;
    },
};
